import React from "react";
import { GOALS } from "./_shared";

export default function LibraryTab({ foodsByGoal }) {
  return (
    <div data-testid="tab-library">
      <h2 className="font-display text-3xl mb-2">Your Library</h2>
      <p className="text-zinc-500 text-sm mb-8">Your saved favorite foods, grouped by goal. Edit them on the Nutrition tab.</p>

      <div className="border border-zinc-800 bg-[#141414] mb-10" data-testid="library-favorites">
        <div className="px-5 py-3 border-b border-zinc-800 text-[10px] tracking-[0.3em] uppercase text-[#E5B43A]">Favorite Foods</div>
        <div className="divide-y divide-zinc-900">
          {GOALS.map((g) => {
            const foods = foodsByGoal[g.id] || [];
            return (
              <div key={g.id} className="px-5 py-4 flex items-start gap-4" data-testid={`library-favs-${g.id}`}>
                <div className="w-24 shrink-0 pt-1">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">{g.label}</div>
                  <div className="text-xs text-zinc-600 mt-0.5">{foods.length}</div>
                </div>
                <div className="flex-1 min-w-0">
                  {foods.length === 0 ? (
                    <span className="text-xs text-zinc-600 italic">None yet</span>
                  ) : (
                    <div className="flex flex-wrap gap-1.5">
                      {foods.map((f) => (
                        <span key={f} className="border border-zinc-700 px-2 py-0.5 text-[11px] text-zinc-300 break-all">{f}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="border border-zinc-800 bg-[#141414] px-5 py-4 text-sm text-zinc-400">
        <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mr-2">Heads up</span>
        Only your current meal plan and workout plan are kept on the dashboard. Each plan stays for <b className="text-white">30 days</b>; you have up to <b className="text-white">3 generations</b> per type per cycle.
      </div>
    </div>
  );
}
